import React from 'react';
import { motion } from 'framer-motion';
import { SalesButton } from '../ui/SalesButton';
export function FinalClose() {
  return <section className="py-24 bg-white text-center" data-id="element-31">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-32">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-33">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1B5E20] mb-6" data-id="element-34">
            Ready to Feel Light Again?
          </h2>

          <div className="space-y-4 text-xl text-[#374151] mb-10" data-id="element-35">
            <p data-id="element-36">You don’t need another extreme cleanse.</p>
            <p data-id="element-37">You need a simple daily reset.</p>
            <p className="font-bold text-[#1B5E20]" data-id="element-38">
              Wake up looking and feeling like yourself again.
            </p>
          </div>

          <SalesButton size="xl" onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-39">
            Start Your LymphoriaX™ Reset Today
          </SalesButton>

          <p className="mt-6 text-sm text-gray-500 font-medium" data-id="element-40">
            Free Worldwide Shipping • 90-Day Guarantee • Thousands of Women
            Worldwide
          </p>
        </motion.div>
      </div>
    </section>;
}